import React from "react";
import { CheckIcon, GlobeIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { CountdownTimer } from "./CountdownTimer";
import { images } from "../data/landing";
const finalItems = ["Six specialized educational volumes", "Five professional resources", "Instant digital access", "One-time payment", "Seven-day refund guarantee"];
export function FinalCTA() {
  return <section className="w-full bg-ink" data-id="element-119" data-mp="m3wxeqeoorgz">
      <div className="mx-auto max-w-4xl px-5 py-16 text-center sm:px-8 md:py-24" data-id="element-120" data-mp="m2vmclxo44z9">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-gold sm:text-sm" data-id="element-121" data-mp="h5c65gheti4o">
          Ready to organize your facial aesthetic clinical references?
        </p>
        <h2 className="mt-4 font-serif text-[2rem] font-bold leading-tight text-cream sm:text-5xl" data-id="element-122" data-mp="qwq25ea5jzt2">
          Get the Complete Collection for Just <span className="text-gold" data-id="element-123" data-mp="14vpuavwviwtz">$27 USD</span>
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-muted sm:text-lg" data-id="element-124" data-mp="zxefe6rq1w4w">
          You have invested time and effort in developing your professional knowledge. Now you can bring educational
          references, case studies, assessment worksheets, and documentation tools together in one place.
        </p>

        <img src={images.mockup} alt="HOF Clinical Blueprint complete collection" className="mx-auto mt-8 w-full max-w-xl" loading="lazy" data-id="element-125" data-mp="2m1j7f8w4qvhb" />

        <ul className="mx-auto mt-8 inline-grid gap-2.5 text-left" data-id="element-126" data-mp="2v3sji371qwwt">
          {finalItems.map(item => <li key={item} className="flex items-center gap-3 text-base font-medium text-cream sm:text-lg" data-id="element-127" data-mp="3023tcdxcd7f1">
              <CheckIcon className="h-5 w-5 shrink-0 text-gold" strokeWidth={3} aria-hidden="true" data-id="element-128" data-mp="34t2blj1w4fkx" />
              {item}
            </li>)}
        </ul>

        <div className="mt-8 flex justify-center" data-id="element-129" data-mp="3eri1jip6lisu">
          <CTAButton size="xl" label="Get HOF Clinical Blueprint™ Now" data-id="element-130" data-mp="3est279nbyafq" />
        </div>
        <p className="mt-3 text-xs text-muted" data-id="element-131" data-mp="3iu4y1wwsrrwd">Only $27 USD · Instant digital access · One-time payment · Seven-day guarantee</p>

        <div className="mx-auto mt-8 max-w-md" data-id="element-132" data-mp="1jolcubdgyfad">
          <CountdownTimer data-id="element-133" data-mp="1eps8p9k2o0mv" />
        </div>

        <p className="mx-auto mt-6 flex max-w-md items-start justify-center gap-2 text-sm text-muted" data-id="element-134" data-mp="1eqtlpjknex78">
          <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-135" data-mp="1shyd5ydv4j6h" />
          Currency is converted automatically according to your country and payment provider.
        </p>
      </div>
    </section>;
}